import { DunningBlockReason } from "@/api-schema-enums";
import { sortByLabel } from "@/common/helpers/sort-by-label";

export const DUNNING_BLOCK_REASON_LABEL_KEYS: Record<DunningBlockReason, string> = {
  [DunningBlockReason.Disputed]: "fia:DunningReasonDisputed",
  [DunningBlockReason.Complaint]: "fia:DunningReasonComplaint",
  [DunningBlockReason.DebtorClarification]: "fia:DunningReasonDebtorClarification",
  [DunningBlockReason.Export]: "fia:DunningReasonExport",
  [DunningBlockReason.FinancedVehicles]: "fia:DunningReasonFinancedVehicles",
  [DunningBlockReason.Warranty]: "fia:DunningReasonWarranty",
  [DunningBlockReason.Collection]: "fia:DunningReasonCollection",
  [DunningBlockReason.InsuranceClaimLawsuit]: "fia:DunningReasonInsuranceClaimLawsuit",
  [DunningBlockReason.DownPaymentReceived]: "fia:DunningReasonDownPaymentReceived",
  [DunningBlockReason.Lawyer]: "fia:DunningReasonLawyer",
  [DunningBlockReason.Insurance]: "fia:DunningReasonInsurance",
  [DunningBlockReason.PaymentAgreement]: "fia:DunningReasonPaymentAgreement",
};

export function getDunningBlockReasonOptions(translate: (key: string) => string, language: string) {
  return sortByLabel(
    Object.values(DunningBlockReason).map((reason) => ({
      id: reason,
      name: translate(DUNNING_BLOCK_REASON_LABEL_KEYS[reason]),
    })),
    (option) => option.name,
    { getValue: (option) => option.id, locale: language },
  );
}
